import { render, staticRenderFns } from "./factoryDes.vue?vue&type=template&id=54164fd9&scoped=true"
import script from "./factoryDes.vue?vue&type=script&lang=js"
export * from "./factoryDes.vue?vue&type=script&lang=js"
import style0 from "./factoryDes.vue?vue&type=style&index=0&id=54164fd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54164fd9",
  null
  
)

export default component.exports